export default __webpack_public_path__ + "static/Inter-Italic-Variable-831252f8ba7e1b5b243228bfa403d94b.ttf";